module.exports = "/wp-content/plugins/farmacy/assets/js/images/map-marker-farmacy-4dbfd04df81a5d2ba56207a750955b4e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/locations-map/img/map-marker-farmacy.png
 ** module id = 402
 ** module chunks = 1 7 9 33 51
 **/